import { render, staticRenderFns } from "./CorporateBusiness.vue?vue&type=template&id=d42679ac&"
import script from "./CorporateBusiness.vue?vue&type=script&lang=js&"
export * from "./CorporateBusiness.vue?vue&type=script&lang=js&"
import style0 from "./CorporateBusiness.vue?vue&type=style&index=0&id=d42679ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports